import styled from 'styled-components';

export const PolicyLinkLink = styled.a`
    margin: 0 4px;
    cursor: pointer;
    text-decoration: none;
    font-weight: 700;
    color: ${({ theme }) => theme.black};
`;
